/**
 * @Author: Syam Pillai <syambhai>
 * @Date:   2018-02-26T15:29:15+05:30
 * @Email:  syam@wealthy.in
 * @Last modified by:   apple
 * @Last modified time: 2018-02-27T11:24:26+05:30
 */

import PropTypes from "prop-types";
import styled, {css} from "styled-components";

/**
 * Basic heading component to use all over the app
 */
const Heading = styled.h1`
  font-family: var(--primary-font);
  color: var(--primary-color);
  text-transform: capitalize;
  /* -webkit-font-smoothing: antialiased; */
  ${props =>
    props.type === "primary" &&
    css`
    font-size: 2.5em;
    font-weight: 700;
  `}
  ${props =>
    props.type === "secondary" &&
    css`
    font-size: 1.75em;
    font-weight: 500;
    margin: 0;
  `}
  ${props =>
    props.type === "tertiary" &&
    css`
    font-size: 1.25em;
    font-weight: 400;
    margin: 0;
  `}
  ${props =>
    props.fontSize &&
    css`
    font-size: ${props.fontSize};
  `}
  ${props =>
    props.color &&
    css`
    color: ${props.color};
  `}
  ${props => props.additionalStyles && css(...props.additionalStyles)}
`;

const propTypes = {
  /** Type of the Text field */
  additionalStyles: PropTypes.string,

  /** User defined heading color, **eg: '#cc45a2' or 'orange'** */
  color: PropTypes.string,

  /** User defined text font-size, **eg: '1em'** */
  fontSize: PropTypes.string,

  /** Any additional styles that need be applied. Should be in backticks `` */
  type: PropTypes.oneOf(["primary", "secondary", "tertiary"]).isRequired
};

const defaultProps = {
  type: "primary"
};

Heading.propTypes = propTypes;
Heading.defaultProps = defaultProps;

/** @component */
export default Heading;
